import { useQuery } from "@tanstack/react-query"
import { useTRPC } from "utils/trpc"

const useChains = () => {
  const trpc = useTRPC()
  return useQuery(trpc.chains.getChains.queryOptions())
}

export default useChains
